import React from "react";
import "./Privacy.css";
import Header from "./Header";
import Footer from "./Footer";

const Terms = () => {
  return (
    <>
    <Header />
    <section className="legal-container">

      <h1>Terms and Conditions – Intown</h1>

      <p><strong>Effective Date:</strong> 04 March 2026</p>

      <p>
        Welcome to Intown. These Terms and Conditions (“Terms”) govern your use of the Intown mobile application and related services. By accessing or using the Intown app, you agree to comply with and be bound by these Terms.
      </p>

      <p>If you do not agree with these Terms, please do not use the application.</p>

      <h2>1. About Intown</h2>
      <p>
        Intown is a platform that helps users discover nearby participating merchants and explore available in-store benefits. The app connects customers with local businesses for discovery and information purposes.
      </p>

      <p>
        Intown does not sell products directly and does not process in-store transactions between customers and merchants.
      </p>

      <h2>2. User Accounts</h2>
      <p>
        To access certain features, users may need to create an account using phone number verification (OTP).
      </p>

      <p>Users agree to:</p>

      <ul>
        <li>Provide accurate and valid information</li>
        <li>Maintain the security of their account</li>
        <li>Use the app only for lawful purposes</li>
      </ul>

      <p>
        Users are responsible for all activities that occur under their account.
      </p>

      <h2>3. Merchant Listings</h2>

      <p>
        Businesses may register and list their stores on the Intown platform. Merchant information such as:
      </p>

      <ul>
        <li>Business name</li>
        <li>Address</li>
        <li>Contact details</li>
        <li>Description</li>
      </ul>

      <p>
        may be displayed in the app to help users discover nearby services. Intown does not guarantee the availability, quality, or accuracy of services offered by merchants.
      </p>

      <h2>4. Benefits and Offers</h2>

      <p>
        Some participating merchants may provide benefits to Intown users. Important:
      </p>

      <ul>
        <li>Benefits are determined by individual merchants.</li>
        <li>Availability and terms may vary by location or merchant.</li>
        <li>Intown does not guarantee specific savings or benefits.</li>
        <li>Users should confirm details directly with the merchant before making purchases.</li>
      </ul>

      <h2>5. Subscription and Payments</h2>

      <p>
        Certain features of the Intown app may require a subscription. Subscriptions may be offered through Google Play Billing. By purchasing a subscription:
      </p>

      <ul>
        <li>You agree to the pricing and billing terms displayed at the time of purchase.</li>
        <li>Subscriptions may renew automatically unless cancelled through your Google Play account.</li>
        <li>Refunds and billing management are handled by Google Play according to their policies.</li>
      </ul>

      <h2>6. Acceptable Use</h2>

      <p>Users agree not to:</p>

      <ul>
        <li>Use the app for unlawful purposes</li>
        <li>Upload false or misleading information</li>
        <li>Attempt to disrupt or interfere with the app’s operation</li>
        <li>Misuse merchant listings or platform services</li>
      </ul>

      <h2>7. Intellectual Property</h2>

      <p>
        All content within the Intown app, including logos, design, software, and branding, is the property of Intown unless otherwise stated. Users may not copy, reproduce, distribute, or modify any content without permission.
      </p>

      <h2>8. Limitation of Liability</h2>

      <p>
        Intown is not responsible for: Transactions between users and merchants; Merchant service quality; Disputes between customers and businesses; Any loss or damages resulting from merchant interactions.
      </p>

      <h2>9. Termination</h2>

      <p>
        Intown reserves the right to suspend or terminate user accounts if users violate these Terms or misuse the platform.
      </p>

      <h2>10. Changes to Terms</h2>

      <p>
        We may update these Terms from time to time. Continued use of the app after changes indicates acceptance of the updated Terms.
      </p>

      <h2>11. Governing Law</h2>

      <p>
        These Terms are governed by the laws of India. Any disputes shall be subject to the jurisdiction of courts in India.
      </p>

      <h2>12. Contact Information</h2>

      <p>
        <strong>Email:</strong> support@intownlocal.com<br />
        <strong>Company:</strong> Yagnavihar Lifestyle Private Limited<br />
        <strong>Location:</strong> Hyderabad, India
      </p>

    </section>
    <Footer />
    </>
  );
};

export default Terms;